export default "__VITE_ASSET__d5f79dc0__"